import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSend$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSend extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '975a93e908975fdf9574567b0096952d0a484e37', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4a10bee3e67602a03bea62a3d65e08f6f0ada932', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ea78ddcdb56682ba26f52f3f910e0cc6b0df7928', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.723 11.257a.5.5 0 0 0 0-.894l-14-7.001A.5.5 0 0 0 4 3.809V9.61l8.753 1.095c.292.036.292.46 0 .496L4 12.295v5.516a.5.5 0 0 0 .724.447z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-send", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-send"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-send":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSend$1);
            }
            break;
    } });
}

const CosmosIconSend = CosmosIconSend$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSend, defineCustomElement };
